// Translations
import accessKeyDeletionDialog from '../components/access-key-deletion-dialog/translations/en'

// Translation: Account > Integrations > Access keys (English)
export default Object.freeze({
	components: { accessKeyDeletionDialog },
	fallback: 'You do not have any access keys',
	subtitle: 'Manage your access keys here',
	table: {
		fields: {
			actions: {
				label: 'Actions'
			},
			creationDate: {
				label: 'Creation date'
			},
			creator: {
				label: 'Creator'
			},
			expirationDate: {
				fallback: '∞',
				label: 'Expiration date'
			},
			key: {
				label: 'Key'
			},
			name: {
				fallback: 'Unnamed',
				label: 'Name'
			},
			type: {
				admin: 'Admin',
				label: 'Type',
				member: 'Member'
			}
		}
	},
	title: 'Team access keys'
})
